import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 16,
    width: 240
  }
}));
//TODO: move to components
const HeaderButton = ({ children, ...props }) => {
  const classes = useStyles({})
;
  return (
    <Button className={classes.root} color="primary" variant="contained" {...props}>
      {children}
    </Button>
  );
};

export default HeaderButton;
